import { useTranslation } from 'react-i18next';
import Stars from '@/components/general/Stars';
import { getTranslatedReview } from '../utils';

const HotelCardReviewComponent = ({ hotel }) => {
	const { t } = useTranslation();
	const { stars, hasReview, review, stars_hide } = hotel;

	const hideSeparator = stars_hide && !hasReview;

	return (
		<div className="hotel-review">
			<Stars stars={stars} hide={stars_hide} />
			{hasReview ? (
				<>
					<span className="review-score">{review.score}</span>
					<span>{getTranslatedReview(review.description, t)}</span>
					<span>|</span>
					<span>{review.votes.toLocaleString() + ' ' + t('Reviews')}</span>
				</>
			) : (
				<>
					{!hideSeparator && <span>|</span>}
					<span>{t('ScoreNotAvailable')}</span>
				</>
			)}
		</div>
	);
};

export default HotelCardReviewComponent;
